import { render, staticRenderFns } from "./EcoPopup.vue?vue&type=template&id=3cec4717&scoped=true"
import script from "./EcoPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./EcoPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EcoPopup.vue?vue&type=style&index=0&id=3cec4717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec4717",
  null
  
)

export default component.exports